import styles from "./ngo-landing.module.css";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import useApp from "../../../hooks/useApp";
import { Button } from "../../../components";
import { AppRoutes } from "../../../constants";
import { useCallback, useEffect } from "react";

export enum CampaignQueryParam {
  CAMPAIGN_ID = "campaignId",
  TYPE = "type",
}

const NGOLanding = () => {
  const navigate = useNavigate();
  const { organization } = useParams();
  const [searchParams] = useSearchParams();
  const {
    state: { organization: organizationDetails },
  } = useApp();

  const campaignId = searchParams.get(CampaignQueryParam.CAMPAIGN_ID);
  const type = searchParams.get(CampaignQueryParam.TYPE);

  useEffect(() => {
    if (!campaignId || !type) {
      navigate(AppRoutes.APP.LOGIN, { replace: true });
    }
  }, [campaignId, type, navigate]);

  const handleClickCity = useCallback(() => {
    if (organizationDetails?.isVoting) {
      navigate(
        `${AppRoutes.NGO.DONATE(organization as string)}${
          !!organizationDetails?.isVoting ? "?voting=yes" : ""
        }`
      );
    } else {
      navigate(AppRoutes.NGO.DONATE(organization as string));
    }
  }, [organizationDetails, navigate, organization]);

  return (
    <div>
      <div className={styles.header}>
        <h2>{organizationDetails?.title}</h2>
        <p>{organizationDetails?.description}</p>
      </div>
      <div className={styles.content}>
        <div className={styles.btnContainer}>
          <Button variant="contained" color="success" onClick={handleClickCity}>
            Pick your city
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NGOLanding;
